import{jsx as e}from"react/jsx-runtime";import"react";function t(t){var r=t.id,i=t.value;return e("input",{type:"hidden",id:r,name:r,value:void 0===i?"":i})}export{t as default};
